// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2SAHM","colMin":"styles_colMin__1QYeO","colCheckbox":"styles_colCheckbox__2tJA_"};